module.exports = __webpack_public_path__ + "static/media/20210401_202306_685_IMG_0012.7004d557.jpg";